import { Box, Center, Spinner, Text } from "@reverb-ui/react";
import React, { useContext, useEffect, useState } from "react";
import OwnerAddAlertModal from "./owner-add-alert-modal";
import RemoveUserAlertModal from "./remove-user-alert-modal";
import RoleAlertModal from "./role-alert-modal";
import { SearchUsersInput } from "./search-users-input";
import { UserRolesTable } from "./user-roles-table";
import { EmployeeRolesCodes, EmployeeRolesDescription, } from "@/shared/domain/entities/employee";
import { UsersTabContext } from "@/features/first-access/presentation/context-api/users-tab-provider";
export var UsersTab = function (_a) {
    var clientRockId = _a.rockId, locationId = _a.locationId;
    var _b = useContext(UsersTabContext), loading = _b.loading, employeesRoles = _b.employeesRoles, getEmployeesRoles = _b.getEmployeesRoles, unbindEmployeeClient = _b.unbindEmployeeClient, bindEmployeeRole = _b.bindEmployeeRole, DEFAULT_ROLES = _b.DEFAULT_ROLES;
    useEffect(function () {
        getEmployeesRoles(clientRockId);
    }, [clientRockId]);
    var _c = useState(false), isRemoveUserAlertModalOpen = _c[0], setIsRemoveUserAlertOpen = _c[1];
    var _d = useState(false), changeOwnerAlertModalOpen = _d[0], setChangeOwnerAlertModalOpen = _d[1];
    var _e = useState(false), changeRoleToEmployeeModalOpen = _e[0], setChangeRoleToEmployeeModalOpen = _e[1];
    var _f = useState(false), changeRoleToAdminModalOpen = _f[0], setChangeRoleToAdminModalOpen = _f[1];
    var _g = useState(""), employeeRockId = _g[0], setEmployeeRockId = _g[1];
    var removeUserAlertModal = function (employeeRockId) {
        setEmployeeRockId(employeeRockId);
        if (!loading) {
            setIsRemoveUserAlertOpen(true);
        }
    };
    var updateRole = function (employeeRockId, newRole) {
        setEmployeeRockId(employeeRockId);
        var newRoleIsOwner = newRole === EmployeeRolesCodes.OWNER;
        var newRoleIsEmployee = newRole === EmployeeRolesCodes.DEFAULT;
        var newRoleIsAdmin = newRole === EmployeeRolesCodes.ADMIN;
        if (newRoleIsOwner) {
            setChangeOwnerAlertModalOpen(true);
        }
        else if (newRoleIsEmployee) {
            setChangeRoleToEmployeeModalOpen(true);
        }
        else if (newRoleIsAdmin) {
            setChangeRoleToAdminModalOpen(true);
        }
    };
    var unbindUser = function () {
        unbindEmployeeClient(clientRockId, employeeRockId);
        setIsRemoveUserAlertOpen(false);
    };
    var changeUserToOwner = function () {
        bindEmployeeRole(clientRockId, employeeRockId, EmployeeRolesCodes.OWNER);
        setChangeOwnerAlertModalOpen(false);
    };
    var changeUserToEmployee = function () {
        bindEmployeeRole(clientRockId, employeeRockId, EmployeeRolesCodes.DEFAULT);
        setChangeRoleToEmployeeModalOpen(false);
    };
    var changeUserToAdmin = function () {
        bindEmployeeRole(clientRockId, employeeRockId, EmployeeRolesCodes.ADMIN);
        setChangeRoleToAdminModalOpen(false);
    };
    var cannotUpdateUser = function (role) {
        return role === EmployeeRolesDescription.OWNER;
    };
    return (React.createElement(Box, { w: "full" },
        React.createElement(SearchUsersInput, { clientRockId: clientRockId, locationId: locationId }),
        loading && (React.createElement(Center, { w: "full", p: 12 },
            React.createElement(Spinner, { color: "blue.500" }))),
        !loading && !employeesRoles.length && (React.createElement(Center, { w: "full", p: 12, flexDirection: "column" },
            React.createElement(Text, { color: "gray.400", fontWeight: "medium", pt: 4 }, "Users not found."))),
        !loading && !!employeesRoles.length && (React.createElement(UserRolesTable, { employeesRoles: employeesRoles, bindEmployeeRole: bindEmployeeRole, cannotUpdateUser: cannotUpdateUser, removeUserAlertModal: removeUserAlertModal, updateRole: updateRole, roles: DEFAULT_ROLES })),
        React.createElement(RemoveUserAlertModal, { isOpen: isRemoveUserAlertModalOpen, onClose: function () { return setIsRemoveUserAlertOpen(false); }, onSubmit: unbindUser, loading: loading }),
        React.createElement(OwnerAddAlertModal, { isOpen: changeOwnerAlertModalOpen, onClose: function () { return setChangeOwnerAlertModalOpen(false); }, onSubmit: changeUserToOwner }),
        React.createElement(RoleAlertModal, { isOpen: changeRoleToEmployeeModalOpen, onClose: function () { return setChangeRoleToEmployeeModalOpen(false); }, onSubmit: changeUserToEmployee, role: "employee" }),
        React.createElement(RoleAlertModal, { isOpen: changeRoleToAdminModalOpen, onClose: function () { return setChangeRoleToAdminModalOpen(false); }, onSubmit: changeUserToAdmin, role: "admin" })));
};
